.openInNewTab {
  display: flex;
  align-items: flex-end;
  gap: 0.5em;
}
